import React from 'react';
import advisor from "./Advisor.svg";
export var Advisor = function Advisor() {
  return /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: advisor,
    style: {
      display: 'block',
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  });
};